<template>
    <v-form ref="form"
            v-model="valid"
            lazy-validation>


        <v-text-field v-model="Id"
                      label="Id"
                      readonly></v-text-field>


        <v-text-field v-model="user_name"
                      label="Usuario"
                      readonly></v-text-field>





        <v-data-table :headers="headers"
                      :items="array_usuario_membresia"
                      :items-per-page="5"
                      :search="search"
                      class="elevation-1">




            <template v-slot:item.action="{ item }">
                <v-btn small @click="membresia(item)"> <v-icon left>mdi-draw</v-icon>Membresia</v-btn>
                <v-btn small @click="dialog=true;selected_id=item.id;"><v-icon left>delete</v-icon>Eliminar</v-btn>
            </template>
        </v-data-table>

        <template>
            <v-container fluid>
                <v-row align="center">
                    <v-col cols="2">
                        <v-subheader>Membresias</v-subheader>
                    </v-col>


                    <v-col cols="4">
                        <v-menu v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="date"
                                              label="Fecha de Asignacion"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>


                    <v-col cols="4">
                        <v-select v-model="select"
                                  :hint="`${select.Id}, ${select.nombre}`"
                                  :items="items"
                                  item-text="nombre"
                                  item-value="Id"
                                  label="Seleccione membresia"
                                  persistent-hint
                                  return-object
                                  single-line></v-select>
                    </v-col>

                    <v-col cols="2">
                        <v-btn @click="validate_and_save()" small>Asignar Membresia</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </v-form>
</template>
<script>
    import axios from "axios";

    var token = window.localStorage.getItem('jwt_token');
    var headers = {
        Authorization: "Bearer " + token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    export default {
        data: () => ({
            select: {},
            items: [
            ],
            search: "",
            headers: [
                { text: 'Id', align: 'start', sortable: false, value: 'id' },
                { text: 'Fecha Inicio', align: 'start', sortable: false, value: 'fecha_inicio' },
                { text: 'Fecha Fin', value: 'fecha_fin' },
                { text: 'Firmas Realizadas', value: 'firmas_realizadas' },
                { text: 'Firmas Autorizadas', value: 'firmas_autorizadas' },
                { text: 'Estado', value: 'estado' },
                { text: 'Codigo Membresia', value: 'membresiaId' },
                { text: 'Nombre Membresia', value: 'membresia' }
            ],
            dialog: false,
            valid: true,
            menu: false,
            date: new Date().toISOString().substr(0, 10),
            modal: false,
            menu2: false,
            Nombre: '',
            dias_vigencia: '',
            firmas_permitidas: '',
            errorMessages: '',
            Id: '0',
            user_name: '',
            notificacion_exito: false,
            texto_notificacion: '',
            array_usuario_membresia: [],
            rules: {
                required: value => !!value || 'Campo Requerido.',
                positivo_mayor_cero: value => 0 < Number(value) || 'Campo debe ser mayor a cero'
            }
        }),
        mounted() {
            this.Id = this.$route.params.Id;
            this.user_name = this.$route.params.Usuario;
            
            this.cargar_datos_membresia();
            this.cargar_lista_membresia();
        },
        methods: {
            agregar_membresia() {
                
            },
            validar_numero_mayor_cero(v) {
                
                if (v <= 0) {
                    this.errorMessages = 'valor ingresado debe ser mayor a 0';
                }
                else
                    this.errorMessages = '';

                return true;
            },
            reset() {
                this.$router.push({ name: "index_membresia" });
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },
            validate_and_save() {
                //  if (this.$refs.form.validate()) {
                //      this.snackbar = true      
                console.log('asignando membresia ' + this.select.id);
                let getuser = axios.post('/Usuario/AsignarMembresia', { 'Id': 0, 'fecha_inicio': this.date, 'fecha_fin': null, 'firmas_realizadas': 0, 'firmas_autorizadas': 0, 'estado': 'ACTIVO', 'MembresiaId': Number(this.select.id), 'ClienteId': Number(this.Id) }/*,  { 'headers': headers }*/)
                return getuser.then((callback) => {
                    let resultado = callback.data;

                    this.texto_notificacion = 'Operacion finalizada con exito';
                    this.notificacion_exito = true;

                    return callback;

                }).catch((error) => {
                 
                    this.texto_notificacion = 'Error al realizar la operacion : ' + error;
                    this.notificacion_exito = true;

                    return false;
                });
                //  }
                //  else {
                //      console.log("estoy en el else");
                //  }
            },
            cargar_datos_membresia() {
                const getMembresias = axios.get('/Usuario/listar_membresia?id=' + this.Id);

                return getMembresias.then((callback) =>
                {
                    
                    this.array_usuario_membresia = callback.data;
                }).catch((error) => {
                    this.texto_notificacion = 'Error al cargar_datos_membresia : ' + error;
                    this.notificacion_exito = true;
                });
            },
            cargar_lista_membresia() {
                const getMembresias = axios.get('/membresia/');
                return getMembresias.then((callback)=> {
                    this.items = callback.data;
                }).catch((error) => {
                    this.texto_notificacion = 'Error al cargar_lista_membresia : ' + error;
                    this.notificacion_exito = true;

                    return false;
                });
            },
        },
    };
</script>